export const BILLING_CHECKOUT_ID_SEARCH_PARAM = 'checkout_id'

export type BillingCheckoutSearch = {
  section?: string
  checkout_id?: string
}

function optionalString(value: unknown): string | undefined {
  return typeof value === 'string' && value.length > 0 ? value : undefined
}

/**
 * Parses the public checkout-return query contract. Keep this leaf helper out
 * of the route modules so URL regressions do not initialize the application,
 * auth store, or Supabase as a test side effect.
 */
export function parseBillingCheckoutSearch(
  search: Record<string, unknown>
): BillingCheckoutSearch {
  return {
    section: optionalString(search.section),
    checkout_id: optionalString(search[BILLING_CHECKOUT_ID_SEARCH_PARAM]),
  }
}

export function parseBillingCheckoutUrl(
  url: string,
  defaultSection?: string
): BillingCheckoutSearch {
  const parsedUrl = new URL(url, 'http://localhost')
  const parsedSearch = parseBillingCheckoutSearch(Object.fromEntries(parsedUrl.searchParams))

  return {
    section: parsedSearch.section ?? defaultSection,
    checkout_id: parsedSearch.checkout_id,
  }
}

export function buildCompanySettingsSearch<TSection extends string>(
  section: TSection,
  checkoutId?: string
): { section: TSection; checkout_id?: string } {
  return { section, checkout_id: checkoutId }
}

export function removeBillingCheckoutId(url: string): string {
  const parsedUrl = new URL(url)
  parsedUrl.searchParams.delete(BILLING_CHECKOUT_ID_SEARCH_PARAM)
  return parsedUrl.toString()
}
